import styled, { css } from "styled-components";

import Paper from "components/Layout/Paper";

import { COLORS } from "constants/colorScheme";

const CARD_HEIGHT = 120;
const PUBLISH_CONTROL_MIN_WIDTH = 200;

export const Container = styled.div`
  display: flex;
  flex-direction: row;

  background-color: ${COLORS.WHITE};
  border-radius: 8px;
`;

export const ImageContainer = styled.div`
  min-width: 120px;
  min-height: ${CARD_HEIGHT}px;

  background-image: url(${({ image }: { image: string }) => image});
  background-size: cover;

  border-radius: 8px;
`;

export const DetailsContainer = styled(Paper)`
  display: flex;
  justify-content: center;

  height: ${CARD_HEIGHT}px;
  width: 100%;

  padding: 24px 24px 16px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TitleWrapper = styled.div`
  margin-bottom: 4px;
`;

export const BottomControlsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const ControlWrapper = styled.div`
  margin-right: 40px;

  ${({ isPublishControl }: { isPublishControl?: boolean }) =>
    isPublishControl &&
    css`
      min-width: ${PUBLISH_CONTROL_MIN_WIDTH}px;
    `}
`;

export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  margin-right: 24px;

  min-width: 165px;
`;

export const StatusWrapper = styled.div``;
